import PotreeViewer from '../Components/PotreeViewer.jsx'

function PotreePage() {
  return <div className="full-screen">
    <PotreeViewer/>
  </div>
}

export default PotreePage
